import {
    MatchesSnapshot,
    SportOverviewMarketsSnapshot,
    SportOverviewMatchSnapshot,
    SportOverviewTournamentSnapshot
} from '../../../dto/SnapshotEnvelope';
import { Map } from 'immutable';
import { PushEntity, PushEvent, PushPayload } from '../../../dto/PushEnvelope';
import { onOverviewMarketsSnapshot } from '../handlers/marketHandlers';
import { onTournamentPush, onTournamentsSnapshotMerge } from '../handlers/tournamentHandlers';
import { onMatchesSnapshotMerge, onMatchPush } from '../handlers/matchHandlers';
import { MatchIdentity } from '../../../dto';
import fp from 'lodash/fp';

export const clearOverviewSportMatches = (sportCode: string) => db =>
    db
        .deleteIn(['turboLive', 'overview', sportCode, 'matches'])
        .deleteIn(['turboLive', 'overview', sportCode, 'matchIdsByTournament'])
        .deleteIn(['turboLive', 'overview', sportCode, 'matchIdsByStartTime'])
        .deleteIn(['turboLive', 'overview', sportCode, 'tournaments'])
        .deleteIn(['turboLive', 'overview', sportCode, 'tournamentIdsByOrder']);

export const clearOverviewSportMarkets = (sportCode: string) => db =>
    db.deleteIn(['turboLive', 'overview', sportCode, 'markets']);

export const sportOverviewMarketsSnapshot = (sportCode: string, snapshot: SportOverviewMarketsSnapshot) => (
    db: Map<string, any>
) => {
    return db.updateIn(['turboLive', 'overview', sportCode], Map(), onOverviewMarketsSnapshot(snapshot.markets));
};

export const sportOverviewTournamentSnapshot = (sportCode: string, snapshot: SportOverviewTournamentSnapshot) => (
    db: Map<string, any>
) => {
    const updateFn = fp.compose(
        onTournamentsSnapshotMerge(snapshot.tournament == null ? [] : [snapshot.tournament]),
        onMatchesSnapshotMerge(snapshot.matches)
    );
    return db.updateIn(['turboLive', 'overview', sportCode], Map(), db => updateFn(db));
};

export const sportOverviewMatchSnapshot = (sportCode: string, snapshot: SportOverviewMatchSnapshot) => (
    db: Map<string, any>
) => {
    return db.updateIn(
        ['turboLive', 'overview', sportCode],
        Map(),
        onMatchesSnapshotMerge(snapshot.match == null ? [] : [snapshot.match])
    );
};

export const sportOverviewPush = (sportCode: string, push: PushPayload) => (db: Map<string, any>) => {
    switch (push.t) {
        case PushEntity.MATCH:
            return db.updateIn(['turboLive', 'overview', sportCode], Map(), onMatchPush(push.e, push.d));
        case PushEntity.TOURNAMENT:
            return db.updateIn(['turboLive', 'overview', sportCode], Map(), onTournamentPush(push.e, push.d));
        case PushEntity.MARKET:
            // TODO zatial nepushujeme market
            return db;
        default:
            return db;
    }
};

export const liveMatchIdsSnapshot = (snapshot: MatchesSnapshot) => (db: Map<string, any>) => {
    return db.setIn(
        ['turboLive', 'allMatchIds'],
        Map(snapshot.matches.map(matchIdentity => [matchIdentity.id, matchIdentity]))
    );
};

export const liveMatchIdsPush = (push: PushPayload) => (db: Map<string, any>) => {
    return db.updateIn(['turboLive', 'allMatchIds'], Map(), (matches: Map<string, MatchIdentity>) => {
        switch (push.e) {
            case PushEvent.CREATED:
                return matches.set(push.d.id, push.d as MatchIdentity);
            case PushEvent.DELETED:
                return matches.delete(push.d.id);
            default:
                console.error(`Invalid PushEvent ${push.e}`);
                return matches;
        }
    });
};
